import { debounce } from 'throttle-debounce';
import { createBrowserHistory } from 'history';

import { IApplicationState } from '../../../shared/types/redux';

const history = createBrowserHistory();

function queryStringUpdaterFn(state: IApplicationState) {
  if (window.location.search.slice(1) !== state.queryString) {
    const newLocation = {
      pathname: history.location.pathname,
      search: `?${state.queryString}`,
      hash: history.location.hash,
      state: history.location.state,
    };

    history.replace(newLocation);
  }
}

export const queryStringUpdater = debounce(300, queryStringUpdaterFn);
